var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTollingBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2583 6.72501C11.8584 5.16771 14.4529 5.16768 16.0531 6.72501M8.60203 5.11426C11.1166 2.66702 15.1935 2.66698 17.7082 5.11426M6.94649 3.50283C10.3755 0.165686 15.935 0.165759 19.364 3.50283M24.7575 24.7927C24.6669 25.827 23.8269 26.6402 22.7789 26.7059C20.7912 26.8302 17.2955 27 13.0267 27C8.76213 27 5.26913 26.8306 3.28038 26.7062C2.23624 26.6409 1.39715 25.8336 1.30275 24.8035C1.1658 23.3098 1 21.1552 1 19.4797C1 17.7953 1.16763 15.601 1.305 14.0857C1.39844 13.0545 2.23774 12.2457 3.28284 12.1804C5.27202 12.0561 8.76396 11.8867 13.0267 11.8867C17.2935 11.8867 20.788 12.0564 22.7762 12.1807C23.8239 12.2463 24.665 13.0591 24.7548 14.0931C24.8711 15.4329 25 17.39 25 19.4797C25 21.5525 24.8731 23.4734 24.7575 24.7927Z",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTollingBox);
export default __webpack_public_path__ + "static/media/tolling-box.ee18d7a638d41e8b5fc1997a1d6861d1.svg";
export { ForwardRef as ReactComponent };